export default __webpack_public_path__ + "static/media/face.b9c99235.jpg";